import { Properties } from "../../../../core/internal/model/model"
import { InAppMessageEligibilityEvaluateResponse } from "../../../../core/internal/evaluation/service/inappmessage/eligibility/InAppMessageEligibilityEvaluateResponse"
import { InAppMessageLayoutEvaluateResponse } from "../../../../core/internal/evaluation/service/inappmessage/layout/InAppMessageLayoutEvaluateResponse"
import { PropertiesBuilder } from "../../../property/PropertiesBuilder"
import ObjectUtil from "../../../../core/internal/util/ObjectUtil"

export class InAppMessageDeliverEvaluation {
  constructor(
    readonly eligibility: InAppMessageEligibilityEvaluateResponse,
    readonly layout: InAppMessageLayoutEvaluateResponse
  ) {}

  toProperties(): Properties {
    const experimentEvaluation = this.layout.experiment
    if (experimentEvaluation === null) {
      return {}
    }

    const properties = new PropertiesBuilder()
      .add("experiment_id", experimentEvaluation.entity.id)
      .add("experiment_key", experimentEvaluation.entity.key)
      .add("variation_id", experimentEvaluation.result.variation.id)
      .add("variation_key", experimentEvaluation.result.variation.key)
      .add("experiment_decision_reason", experimentEvaluation.result.reason)
      .build()

    return ObjectUtil.fromMap(properties)
  }
}
